import { Button, SxProps, Theme, Typography } from "@mui/material";
import { ReactComponent as IconEmptyData } from "assets/svg/empty-state.svg";
import pxToRem from "theme/base/pxToRem";
import { EmptyStateWrapper } from "./styles";

interface EmptyStateProps {
  sx?: SxProps<Theme>;
  message?: string;
  handleBack?: () => void;
}

const EmptyState = ({
  message = "Không tìm thấy thông tin bạn yêu cầu",
  sx,
  handleBack,
}: EmptyStateProps) => {
  return (
    <EmptyStateWrapper sx={sx}>
      <IconEmptyData />
      <Typography variant="subtitle1" fontWeight={500} sx={{ my: pxToRem(34) }}>
        {message}
      </Typography>
      {!!handleBack && <Button onClick={handleBack}>Quay lại</Button>}
    </EmptyStateWrapper>
  );
};

export default EmptyState;
